module.exports = __webpack_public_path__ + "img/spoenk.152608b1.jpg";